export function isSystemField(namespace: string) {
  return namespace === 'standard' || namespace === 'system' || namespace.startsWith('Extension');
}
